/**
 * /tenants/$slug/posture/compliance/frameworks/$frameworkId/$frameworkVersion — route shim.
 *
 * Validates URL search params via Zod (filter facets), prefetches
 * the framework detail via ensureQueryData, then mounts the page.
 */

import { createFileRoute } from "@tanstack/react-router";
import { frameworkSearchSchema } from "@/features/compliance/navigation";
import { fetchFrameworkDetail } from "@/features/compliance/queries";
import { FrameworkDetailPage } from "@/features/compliance/pages/framework-detail-page";

export const Route = createFileRoute(
  "/_authed/tenants/$slug/posture/compliance/frameworks/$frameworkId/$frameworkVersion",
)({
  validateSearch: (raw: Record<string, unknown>) => frameworkSearchSchema.parse(raw),
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData({
      queryKey: [
        "compliance-v2",
        "framework",
        context.tenant.id,
        params.frameworkId,
        params.frameworkVersion,
      ],
      queryFn: () =>
        fetchFrameworkDetail(
          context.tenant.id,
          params.frameworkId,
          params.frameworkVersion,
        ),
    }),
  component: FrameworkDetailPage,
});
